import { m } from "framer-motion";

const LandingScroller = () => {
  return (
    <div
      id="scroller"
      className="absolute xs:bottom-10 bottom-12 flex justify-center items-center"
    >
      <a href="#about">
        <div className="flex items-center space-x-4">
          <div className="flex flex-col items-center space-y-2">
            <m.div
              initial={{ y: 0, rotate: 45, opacity: 1 }}
              animate={{ y: [0, 10, 0], rotate: 45, opacity: [1, 0.5, 1] }}
              transition={{
                duration: 1,
                repeat: Infinity,
                repeatType: "loop",
              }}
              className="w-4 h-4 border-b-4 border-r-4 border-primary-400 transform rotate-45"
            />
            <m.div
              initial={{ y: 0, rotate: 45, opacity: 0.7 }}
              animate={{ y: [0, 10, 0], rotate: 45, opacity: [0.7, 0.3, 0.7] }}
              transition={{
                duration: 1,
                repeat: Infinity,
                repeatType: "loop",
                delay: 0.3,
              }}
              className="w-4 h-4 border-b-4 border-r-4 border-primary-400 transform rotate-45"
            />
          </div>
          <div className="w-[45px] h-[64px] rounded-3xl border-4 border-primary-400 flex justify-center items-start p-2">
            <m.div
              initial={{ height: 0 }}
              animate={{ height: 30 }}
              transition={{
                duration: 1,
                repeat: Infinity,
                repeatType: "loop",
              }}
              className="w-1 h-3 rounded-full bg-primary-400 mb-1"
            />
          </div>
        </div>
      </a>
    </div>
  );
};

export default LandingScroller;
